import Env from './Env.json';
import Env_stage from './Env_stage.json';
import Env_prod from './Env_prod.json';

import i18n from '@/i18n';
const { global } = i18n;
const { t } = global;

let CODE_ENV_LIST = Env;
if (process.env.NODE_ENV === 'production') {
  CODE_ENV_LIST = Env_prod;
} else if (process.env.VUE_APP_MODE === 'stage') {
  CODE_ENV_LIST = Env_stage;
}

/**
 *  <h3> navigationItem icons </h3>
 *  <br/>
 * [Search Icons!](https://fontawesome.com/icons/)
 * <br/>
 * size :
 * ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']
 */

const SESSION_TIME_OUT = {
  INFINITE: 0,
  nHour: (hour = 1) => {
    const result = hour * 60 * 60 * 1000;
    if (Number.isNaN(result)) return 1 * 60 * 60 * 1000;
    else return result;
  },
  nDay: (day = 1) => {
    const result = day * 24 * 60 * 60 * 1000;
    if (Number.isNaN(result)) return 1 * 24 * 60 * 60 * 1000;
    else return result;
  }
};

const MAIN_PATH = '/dashboard';

// MEMO: i18n에서 사용되는 키값만 string으로 전달
const NAVIGATION_ITEM = [
  {
    title: 'menu.dash-board',
    icon: {
      name: ['fas', 'chart-simple'],
      color: ''
    },
    inner: [
      {
        title: 'menu.dash-board',
        to: '/dashboard'
      }
    ]
  },
  {
    title: 'menu.chat',
    icon: {
      name: ['fas', 'comments'],
      color: ''
    },
    color: '',
    inner: [
      {
        title: 'menu.chat',
        to: '/chatting'
      }
    ]
  },
  {
    title: 'menu.order',
    icon: {
      name: ['fas', 'note-sticky'],
      color: ''
    },
    color: '',
    inner: [
      {
        title: 'menu.order',
        to: '/order'
      }
    ]
  },
  {
    title: 'menu.store',
    icon: {
      name: ['fas', 'shop'],
      color: ''
    },
    color: '',
    inner: [
      {
        title: 'menu.store',
        to: '/shop/list'
      }
    ]
  },
  {
    title: 'menu.product.title',
    icon: {
      name: ['fas', 'boxes-stacked'],
      color: ''
    },
    color: '',
    inner: [
      {
        title: 'menu.product.list',
        to: '/product/list'
      },
      {
        title: 'menu.product.category',
        to: '/product/category'
      },
      {
        title: 'menu.product.recently',
        to: '/product/recent'
      }
    ]
  },
  {
    title: 'menu.member',
    icon: {
      name: ['fas', 'headset'],
      color: ''
    },
    color: '',
    inner: [
      {
        title: 'menu.member',
        to: '/cs'
      }
    ]
  },
  {
    title: 'menu.coupon.title',
    icon: {
      name: ['fas', 'tags'],
      color: ''
    },
    color: '',
    inner: [
      {
        title: 'menu.coupon.issue',
        to: '/coupon/issue'
      },
      {
        title: 'menu.coupon.send',
        to: '/coupon/history'
      }
    ]
  },
  {
    title: 'menu.feedback.title',
    icon: {
      name: ['fas', 'users'],
      color: ''
    },
    color: '',
    inner: [
      {
        title: 'menu.feedback.review',
        to: '/feedback/review'
      },
      {
        title: 'menu.feedback.store-like',
        to: '/feedback/shop'
      },
      {
        title: 'menu.feedback.product-like',
        to: '/feedback/product'
      }
    ]
  },
  {
    title: 'menu.biz-money.title',
    icon: {
      name: ['fas', 'dollar-sign'],
      color: ''
    },
    color: '',
    inner: [
      {
        title: 'menu.biz-money.charging',
        to: '/bizmoney/request'
      },
      {
        title: 'menu.biz-money.transaction',
        to: '/bizmoney/transaction'
      }
    ]
  }
];

const LOGIN_TOKEN_NAME = 'unionglobal_jwt_admin_token';

/**
 * 영업 시간
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null,null,null,null,null]}
 */
export const businessHoursOptions = [
  { label: '매일(월~일)', value: 'WEEK' },
  { label: '평일(월~금)', value: 'WEEKDAY' },
  { label: '주말(토~일)', value: 'WEEKEND' },
  { label: '월요일', value: 'MON' },
  { label: '화요일', value: 'TUE' },
  { label: '수요일', value: 'WED' },
  { label: '목요일', value: 'THU' },
  { label: '금요일', value: 'FRI' },
  { label: '토요일', value: 'SAT' },
  { label: '일요일', value: 'SUN' }
];

/**
 * 휴무일
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null]}
 */
export const weekIndex = [
  { label: '매주', value: 'EVERY_WEEK' },
  { label: '매 월 첫째주', value: 'EVERY_FIRST' },
  { label: '매 월 둘째주', value: 'EVERY_SECOND' },
  { label: '매 월 셋째주', value: 'EVERY_THIRD' },
  { label: '매 월 넷째주', value: 'EVERY_FOURTH' },
  { label: '매 월 다섯째주', value: 'EVERY_FIFTH' }
];

/**
 * 요일
 * @type {[{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},{label: string, value: string},null,null]}
 */
export const weekendIndex = [
  { label: '월요일', value: 'MON' },
  { label: '화요일', value: 'TUE' },
  { label: '수요일', value: 'WED' },
  { label: '목요일', value: 'THU' },
  { label: '금요일', value: 'FRI' },
  { label: '토요일', value: 'SAT' },
  { label: '일요일', value: 'SUN' }
];

/**
 * 결제방법
 * @type {[{AUTOMATIC_WITHDRAWAL: string},{CARD: string},{CASH: string},{ONLINE_PAYMENT: string}]}
 */
export const PAYMENT_METHOD = {
  AUTOMATIC_WITHDRAWAL: '계좌이체',
  CARD: '카드',
  CASH: '현금',
  ONLINE_PAYMENT: '온라인 결제'
};

/**
 * 주문상태
 * @type {{ORDER_CHECK: string, COOKING: string, CANCELED: string, DELIVERY_COMPLETED: string, ORDER_INCOME: string, DELIVERY: string}}
 */
export const ORDER_STATE = {
  ORDER_INCOME: '주문 접수',
  ORDER_CHECK: '주문 확인',
  COOKING: '조리 중',
  DELIVERY: '배달 중',
  PACKAGING_COMPLETED: '포장 완료',
  PICKUP_COMPLETED: '픽업 완료',

  DELIVERY_ARRIVED: '배달 도착',
  DELIVERY_COMPLETED: '배달 완료',
  ORDER_CANCELLED: '주문 취소'
};

export const ORDER_TYPE = {
  TYPE_DELIVERY: '배달',
  TYPE_VISIT: '방문',
  TYPE_PACKING: '포장'
};

export const BIZ_REQUEST_STATUS = {
  PROCESSING: '처리중',
  INCOME_COMPLETED: '접수완료',
  CHARGE_COMPLETED: '충전완료',
  CANCELED: '취소'
};

export const NOTICE_TYPE = {
  true: '상점 관리자',
  false: '유저'
};
// 게시판 타입
const BOARD_TYPE = {
  NOTICE: { value: 'NOTICE', label: '공지사항' },
  FAQ: { value: 'FAQ', label: '자주묻는질문' }
};
const EMIT_EVENT = {
  BADGE: 'BADGE',
  LATEST: 'LATEST'
};

const CANCELLED_REASON_OPTIONS = {
  NOT_MATCHED: '입금금액 불일치',
  CHECK_FAIL: '입금금액 확인불가'
};

const SSE_TYPE = {
  chat_status: 'CHAT',
  order_status: 'ORDER_STATUS_CHANGED',
  store_disabled: 'STORE_DISABLED',
  new_chat: 'NEW_CHAT',
  leave_chat: 'LEAVE_CHAT'
};

export const LOCALE_CODE = {
  ko: 'ko',
  en: 'en',
  vn: 'vn'
};

export const LOCALE_TRANSLATE_MAP = {
  ko: 'ko',
  en: 'en',
  vn: 'vi'
};

const ConstCode = function () {
  return {
    isDev: process.env.NODE_ENV !== 'production',
    SESSION_TIME_OUT,
    MAIN_PATH,
    CODE_ENV_LIST,
    LOGIN_TOKEN_NAME,
    NAVIGATION_ITEM,
    BOARD_TYPE,
    EMIT_EVENT,
    CANCELLED_REASON_OPTIONS,
    SSE_TYPE,
    getImagePath(path = '', size = 'origin', isFile = false) {
      if (isFile) return '';
      if (/^https?:\/\//i.test(path)) return path;
      if (path.startsWith('/')) path = path.substring(1);
      // return path ? `${CODE_ENV_LIST.FILE_SERVER_URL}/${size}/${path}` : '';
      return path ? `${CODE_ENV_LIST.S3_FILE_SERVER_URL}/${size}/${path}` : '';
    },
    getFilePath(path = '', isFile = false) {
      if (isFile) {
        return '';
      }
      return path ? `${this.CODE_ENV_LIST.FILE_SERVER_URL}${path}` : '';
    }
  };
};

export default ConstCode();
